import React from "react";
import { UncontrolledTooltip } from "reactstrap";

const PlanItem = ({target, message}) => {
    return (
        <UncontrolledTooltip placement="top" trigger="hover" target={target}>
            {message}
        </UncontrolledTooltip>
    );
}

export default PlanItem;